import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import '../styles/plastic.css'
import Plastic1 from '../assets/images/Plastic1.jpg'
import Plastic2 from '../assets/images/Plastic2.jpg'
import Plastic3 from '../assets/images/Plastic3.jpg'
import Plastic4 from '../assets/images/Plastic4.jpg'
const Plastic = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Plastic1,
    Plastic2,
    Plastic3,
    Plastic4,
   
  ];

  // Toggle custom styling
  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div>
      <section className="about-container"> <h1>Plastic Injection Moulding</h1></section>
      <br/><br/>
      <div  className="acer-container">
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Plastic;
